import { t } from "@/i18n-js/instance";
import { annualDiscountPercentage } from "@/react/helpers/planHelpers";
import type { Plan } from "@circle-react/types";
import { Typography } from "@circle-react-shared/uikit/Typography";

const localeRoot = "pricing_plans.plan_settings.plan_selection.plan_selector";

export const AnnualDiscount = ({ plan }: { plan: Plan }) => {
  if (!plan.annual_discount_amount_with_currency) return null;

  return (
    <Typography.BodyXs weight="light">
      {t(`${localeRoot}.annual_amount`, {
        dollar_amount: plan.annual_base_amount_with_currency,
      })}
      <span className="text-green-success-dark ml-1 font-semibold">
        {plan.fetch_discount
          ? t(`${localeRoot}.saved_dollar_amount_with_percentage`, {
              dollar_amount: plan.annual_discount_amount_with_currency,
              percentage: annualDiscountPercentage(plan),
            })
          : t(`${localeRoot}.saved_dollar_amount`, {
              dollar_amount: plan.annual_discount_amount_with_currency,
            })}
      </span>
    </Typography.BodyXs>
  );
};
